import request from '@/utils/request'


//查询列表
export function tagList(data) {
  return request({
    url: '/admin/storeTag/list',
    method: 'post',
    data:data
  })
}

//添加
export function tagAdd(data) {
  return request({
    url: '/admin/storeTag/add',
    method: 'post',
    data:data
  })
}

//修改
export function tagUpdate(data) {
  return request({
    url: '/admin/storeTag/update',
    method: 'post',
    data:data
  })
}

//删除
export function tagInActiveById(params) {
  return request({
    url: '/admin/storeTag/inActiveById',
    method: 'get',
    params: params
  })
}





// WEBPACK FOOTER //
// ./src/api/storeFrontTag.js